// @ vendors
const { Promise } = require('es6-promise');
const { get } = require('lodash');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');
// @ actions
const { requestState } = require('actions/mortgageRequest/mortgageRequestState');
// @ constants
const {
    MORTGAGE_REQUEST_SIMULATION_LINK_CLIENT_REQUEST,
    MORTGAGE_REQUEST_SIMULATION_LINK_CLIENT_SUCCESS,
    MORTGAGE_REQUEST_SIMULATION_LINK_CLIENT_FAILURE,
    MORTGAGE_REQUEST_SAVE_RNC_PERSONAL_DATA_REQUEST,
    MORTGAGE_REQUEST_SAVE_RNC_PERSONAL_DATA_SUCCESS,
    MORTGAGE_REQUEST_SAVE_RNC_PERSONAL_DATA_FAILURE
} = require('constants/actionTypes');

const linkClientInProgress = () => ({
    type: MORTGAGE_REQUEST_SIMULATION_LINK_CLIENT_REQUEST
});

const linkClientSuccess = () => ({
    type: MORTGAGE_REQUEST_SIMULATION_LINK_CLIENT_SUCCESS
});

const linkClientFailure = (error) => ({
    type: MORTGAGE_REQUEST_SIMULATION_LINK_CLIENT_FAILURE,
    data: { error }
});

const savePersonalDataInProgress = () => ({
    type: MORTGAGE_REQUEST_SAVE_RNC_PERSONAL_DATA_REQUEST
});

const savePersonalDataSuccess = () => ({
    type: MORTGAGE_REQUEST_SAVE_RNC_PERSONAL_DATA_SUCCESS
});

const savePersonalDataError = error => ({
    type: MORTGAGE_REQUEST_SAVE_RNC_PERSONAL_DATA_FAILURE,
    data: { error }
});

const linkClient = (token, isClient, history) => (dispatch, getState) => {
    const currentState = getState().mortgageRequestSimulationLinkClient;
    const isAlreadyFetching = currentState.get('isFetching');
    if (!isAlreadyFetching) {
        const requestData = {
            query: {
                'clienteOpenBank': isClient,
                'tokenSimulacion': token
            }
        };

        dispatch(linkClientInProgress());
        return APIPost(dispatch, apiURLBuilder.getURL('mortgageRequestSimulationLinkClient'), requestData)
            .then(() => {
                dispatch(linkClientSuccess());
                dispatch(requestState('/myprofile/mortgage', history));
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(linkClientFailure(response.error));

                    const query = get(response, 'error.status', '') === 400 ? { coHolderError: true } : { other: true };

                    history.push({
                        query,
                        pathname: '/myprofile/mortgage-error'
                    });
                } else {
                    throw response;
                }
            });
    } else {
        return Promise.resolve();
    }
};

const savePersonalData = (token, isClient, history) => (dispatch, getState) => {
    const currentState = getState().mortgageRequestSimulationLinkClient;
    const isAlreadyFetching = currentState.get('isFetching');
    if (!isAlreadyFetching) {
        const requestData = {
            query: {
                'tokenSimulacion': token,
                'clienteOpenBank': isClient
            }
        };
        dispatch(savePersonalDataInProgress());
        return APIPost(dispatch, apiURLBuilder.getURL('mortgageSaveRNCPersonalData'), requestData)
            .then(() => {
                dispatch(savePersonalDataSuccess());
                dispatch(requestState('/myprofile/mortgage'));
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(savePersonalDataError(response.error));
                    const query = get(response, 'error.status', '') === 400 ? { coHolderError: true } : { other: true };
                    history.push({
                        query,
                        pathname: '/myprofile/mortgage-error'
                    });
                } else {
                    throw response;
                }
            });
    } else {
        return Promise.resolve();
    }
};
module.exports = {
    linkClient,
    savePersonalData
};
